import { Button, Form, Input, Select, Space } from "antd";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CardTitle from "../../../../components/common/CardTitle";
import CustomCard from "../../../../components/common/CustomCard";
import {
  useAssignUserToProjectRoleMutation,
  useGetAllPGAreaQuery,
  useGetAllPGRegionQuery,
  useGetAllPGTerritoriesQuery,
  useGetAllPGVendorQuery,
  useGetAllRoleQuery,
} from "../../../../features/portal/Products/productsApi";
import {
  useGetAllUsersQuery,
  useGetSingleUserQuery,
} from "../../../../features/portal/user/userApi";
import useError from "../../../../hooks/useError";
import SidebarLayout from "../../../../layouts/SidebarLayout";
import { toast } from "../../../../lib/toast";
import { capitalize } from "../../../../utils/string";

export default function AddAssignRole() {
  const [selectedRoleName, setSelectedRoleName] = useState("");
  const [selectRegion, setSelectRegion] = useState("");
  const [selectArea, setSelectArea] = useState("");

  const [selectCluster, setSelectCluster] = useState<string | null>(null);
  const [selectedUserId, setSelectedUserId] = useState<string | null>(null);

  const [form] = Form.useForm();
  const navigate = useNavigate();

  const { companyId } = useParams();
  const { projectId } = useParams();
  const { projectName } = useParams();
  const { serviceName } = useParams();

  const [selectedProjectService, setSelectedProjectService] = useState("");

  const backLink = `/admin/users-roll-access/roll-access/product-access/${companyId}/${projectId}/${projectName}/${serviceName}`;

  const { isError, error, isLoading, data } = useGetAllUsersQuery(
    {
      params: {
        company_id: Number(companyId),
        page: 1,
        limit: 1000000000,
      },
    },
    {
      skip: !companyId,
    }
  );

  const {
    isError: isAllRoleError,
    error: allRoleError,
    data: allRoleData,
  } = useGetAllRoleQuery(
    {
      params: {
        projectId: Number(projectId),
        page: 1,
        limit: 100000000,
      },
    },
    {
      skip: !projectId,
    }
  );

  const {
    isLoading: isDetailsLoading,
    isError: isDetailsError,
    error: detailsError,
    data: detailsData,
  } = useGetSingleUserQuery(selectedUserId || "", {
    skip: !selectedUserId,
  });

  const [
    assignUserToProjectRole,
    {
      isError: isAssignRoleError,
      error: assignRoleError,
      isLoading: isAssignRoleLoading,
      isSuccess: isAssignRoleSuccess,
    },
  ] = useAssignUserToProjectRoleMutation();

  const {
    data: getAllPGVendorData,
    isLoading: getAllPGVendorIsLoading,
    isError: getAllPGVendorIsError,
    error: getAllPGVendorError,
  } = useGetAllPGVendorQuery(
    {},
    {
      skip: serviceName === "power_genie" ? false : true,
    }
  );

  const {
    data: getAllPGRegionData,
    isLoading: getAllPGRegionIsLoading,
    isError: getAllPGRegionIsError,
    error: getAllPGRegionError,
  } = useGetAllPGRegionQuery(
    {},
    {
      skip: serviceName === "power_genie" ? false : true,
    }
  );

  const {
    data: getAllPGAreaData,
    isLoading: getAllPGAreaIsLoading,
    isError: getAllPGAreaIsError,
    error: getAllPGAreaError,
  } = useGetAllPGAreaQuery(
    {
      params: {
        region: selectRegion,
      },
    },
    {
      skip: serviceName === "power_genie" ? false : true,
    }
  );

  const {
    data: getAllPGTerritoriesData,
    isLoading: getAllPGTerritoriesIsLoading,
    isError: getAllPGTerritoriesIsError,
    error: getAllPGTerritoriesError,
  } = useGetAllPGTerritoriesQuery(
    {
      params: {
        area: selectArea,
      },
    },
    {
      skip: serviceName === "power_genie" ? false : true,
    }
  );

  useError(isError, error, "Get all users fail");
  useError(isDetailsError, detailsError, "Get single user data fail");
  useError(isAllRoleError, allRoleError, "Get all role data fail");
  useError(isAssignRoleError, assignRoleError, "Role assign fail");
  useError(getAllPGVendorIsError, getAllPGVendorError, "Get vendors data fail");
  useError(getAllPGRegionIsError, getAllPGRegionError, "Get region data fail");
  useError(getAllPGAreaIsError, getAllPGAreaError, "Get area data fail");
  useError(
    getAllPGTerritoriesIsError,
    getAllPGTerritoriesError,
    "Get territories data fail"
  );

  const allsRollData = allRoleData?.data?.data;

  const onFinishRole = (values: any) => {
    const newData = {
      ...values,
      userId: Number(values?.userId),
      projectId: Number(projectId),
    };

    const newDataPG = {
      userId: Number(values?.userId),
      roleId: values?.roleId,
      projectId: Number(projectId),
      pgUserData: {
        area: values?.area,
        email: values?.email,
        employeeId: values?.employeeId,
        nid: values?.nid,
        phoneNumber: values?.phoneNumber,
        region: values?.region,
        suppler: values?.suppler,
        teritory: values?.teritory,
        regionName:
          getAllPGRegionData?.data?.find((el) => el?._id === values?.region)
            ?.regionName || "",
        areaName:
          getAllPGAreaData?.data?.find((el) => el?._id === values?.area)
            ?.areaName || "",
        teritoryName:
          getAllPGTerritoriesData?.data?.find(
            (el) => el?._id === values?.teritory
          )?.teritoryName || "",
        lattitude: 23.7055748,
        longitude: 90.3621026,
        location: {
          type: "Point",
          coordinates: [90.3621026, 23.7055748],
        },
      },
    };

    if (serviceName === "power_genie") {
      assignUserToProjectRole(newDataPG);
      // console.log("newData:", newDataPG);
    } else {
      assignUserToProjectRole(newData);
      // console.log("newData:", newData);
    }
  };

  useEffect(() => {
    if (isAssignRoleSuccess) {
      form.resetFields();
      toast("success", "Successfully user role assign");
      navigate(backLink);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAssignRoleSuccess]);

  useEffect(() => {
    if (selectedUserId && detailsData?.data) {
      form.setFieldsValue({
        email: detailsData?.data?.email,
      });
    } else if (selectedUserId === null) {
      form.setFieldsValue({
        email: "",
      });
    }
  }, [selectedUserId, detailsData?.data, form]);

  return (
    <>
      <SidebarLayout title={`Add New Role`} backLink={backLink}>
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinishRole}
          form={form}
        >
          <CustomCard className=" p-6 pb-0 rounded-b-none">
            <CardTitle>Add New Role</CardTitle>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-3 pt-4 mb-5">
              <Form.Item
                label="Employee Name"
                name="userId"
                rules={[
                  { required: true, message: "Please enter a employee name" },
                ]}
              >
                <Select
                  placeholder="Select Employee"
                  options={data?.data?.users.map((user: any) => ({
                    label: capitalize(user?.username),
                    value: user?.id,
                  }))}
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                  showSearch
                  optionFilterProp="label"
                  value={selectedUserId || undefined}
                  onChange={(value) => setSelectedUserId(value ?? null)}
                />
              </Form.Item>

              <Form.Item
                label="Select Role"
                name="roleId"
                rules={[{ required: true, message: "Please select role" }]}
              >
                <Select
                  placeholder="Select Role"
                  options={
                    allsRollData?.map((role: any) => {
                      let label = role?.roleName;

                      if (label === "edatco") {
                        label = "Admin";
                      } else if (label === "region") {
                        label = "Zonal";
                      } else if (label?.length <= 3) {
                        label = label?.toUpperCase();
                      }

                      return {
                        label,
                        value: role?.id,
                      };
                    }) || []
                  }
                  onChange={(value) => {
                    const selectedRole = allsRollData?.find(
                      (r: any) => r.id === value
                    );
                    setSelectedRoleName(selectedRole?.roleName || "");
                  }}
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                  style={{ width: "100%" }}
                  allowClear
                />
              </Form.Item>

              {/* {["Checker", "Maker", "Approver"].includes(selectedRoleName) && (
                <Form.Item
                  label="Select Wallet"
                  name="wallet_number"
                  rules={[{ required: true, message: "Please select wallet" }]}
                >
                  <Select
                    placeholder="Select Wallet"
                    className="w-full"
                    suffixIcon={<SelectDownIcon />}
                    allowClear
                    // options={
                    //   getCompanyWalletData?.data?.map((item: any) => ({
                    //     label: item.name,
                    //     value: item.name,
                    //   })) || []
                    // }
                  />
                </Form.Item>
              )} */}

              {serviceName === "power_genie" && (
                <>
                  <Form.Item
                    name="phoneNumber"
                    label="Contact Number"
                    rules={[
                      {
                        required: true,
                        message: "Please enter contact number",
                      },
                      {
                        validator: async (_: any, value: string) => {
                          if (!value) {
                            return Promise.resolve();
                          }

                          const phoneRegex = /^(\+88)?(01[3-9])[0-9]{8}$/;
                          if (!phoneRegex.test(value)) {
                            return Promise.reject(
                              new Error(
                                "Please enter a valid Bangladeshi contact number"
                              )
                            );
                          }
                        },
                      },
                    ]}
                  >
                    <Input
                      prefix={"BD "}
                      size="large"
                      placeholder="Mobile No:"
                    />
                  </Form.Item>

                  <Form.Item
                    name="employeeId"
                    label="Employee ID"
                    rules={[
                      {
                        required: true,
                        message: "Please enter employee ID",
                      },
                      {
                        validator: async (_: any, value: string) => {
                          if (!value) return Promise.resolve();

                          const trimmedValue = value.trim();

                          if (/^[-_]/.test(trimmedValue)) {
                            return Promise.reject(
                              new Error("Are not allowed start with '-' or '_'")
                            );
                          }

                          if (trimmedValue.includes(".")) {
                            return Promise.reject(
                              new Error("Decimal points are not allowed")
                            );
                          }

                          if (/\s/.test(trimmedValue)) {
                            return Promise.reject(
                              new Error("Spaces are not allowed")
                            );
                          }

                          if (!/^[a-zA-Z0-9_-]+$/.test(trimmedValue)) {
                            return Promise.reject(
                              new Error(
                                "Only alphabets, digits, hyphens (-), and underscores (_) are allowed."
                              )
                            );
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Enter Employee ID" />
                  </Form.Item>

                  <Form.Item
                    name="email"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Please enter email",
                      },
                      {
                        validator: async (_: any, value: string) => {
                          if (!value) {
                            return Promise.resolve();
                          }

                          const emailRegex =
                            /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
                          const consecutiveInvalidsRegex =
                            /(\.\.|--|-\.)|(\.-)/;

                          if (
                            !emailRegex.test(value) ||
                            consecutiveInvalidsRegex.test(value)
                          ) {
                            return Promise.reject(
                              new Error(
                                "Please enter a valid email (no repeated or mixed special characters)"
                              )
                            );
                          }
                        },
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Enter email" disabled />
                  </Form.Item>

                  <Form.Item
                    name="nid"
                    label="NID"
                    rules={[
                      {
                        required: true,
                        message: "Please enter NID",
                      },
                      {
                        validator: async (_: any, value: string) => {
                          if (!value) {
                            return Promise.resolve();
                          }

                          if (!/^\d+$/.test(value)) {
                            return Promise.reject(
                              new Error("NID must be number")
                            );
                          }

                          if (value.length < 10) {
                            return Promise.reject(
                              new Error("NID should be minimum 10 digits")
                            );
                          }

                          if (value.length > 20) {
                            return Promise.reject(
                              new Error("NID should not exceed 20 digits")
                            );
                          }
                        },
                      },
                    ]}
                  >
                    <Input
                      className="w-full"
                      size="large"
                      placeholder="Enter NID"
                    />
                  </Form.Item>

                  <Form.Item
                    shouldUpdate={(prev, curr) => prev.roleId !== curr.roleId}
                    noStyle
                  >
                    {({ getFieldValue }) => {
                      const roleId = getFieldValue("roleId");
                      const selectedRole = allsRollData?.find(
                        (r: any) => r.id === roleId
                      );
                      const isRequired =
                        selectedRole?.roleName === "Pg" ||
                        selectedRole?.roleName === "Vendor";

                      return (
                        <Form.Item
                          name="suppler"
                          label="Select Vendor"
                          rules={
                            isRequired
                              ? [
                                  {
                                    required: true,
                                    message: "Please select vendor",
                                  },
                                ]
                              : []
                          }
                        >
                          <Select
                            placeholder="Select Vendor"
                            size="large"
                            allowClear
                            showSearch
                            options={
                              getAllPGVendorData?.data?.map((vendor) => ({
                                label: vendor.supplierName,
                                value: vendor._id,
                              })) || []
                            }
                            filterOption={(input, option) =>
                              (option?.label as string)
                                ?.toLowerCase()
                                .includes(input.toLowerCase())
                            }
                            onChange={(vendorId) => {
                              const vendor = getAllPGVendorData?.data?.find(
                                (v) => v._id === vendorId
                              );
                              if (vendor?.region?._id) {
                                setSelectCluster(vendor.region._id);
                                setSelectRegion(vendor.region._id);
                                form.setFieldValue("region", vendor.region._id);
                              } else {
                                setSelectCluster(null);
                                form.setFieldValue("region", undefined);
                              }
                            }}
                          />
                        </Form.Item>
                      );
                    }}
                  </Form.Item>

                  <Form.Item
                    name="region"
                    label="Select Cluster"
                    rules={[
                      {
                        required: true,
                        message: "Please select cluster",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select cluster"
                      size="large"
                      allowClear
                      showSearch
                      options={
                        getAllPGRegionData?.data?.map((region) => ({
                          label: capitalize(region.regionName),
                          value: region._id,
                        })) || []
                      }
                      filterOption={(input, option) =>
                        (option?.label as string)
                          ?.toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      onChange={(val) => {
                        setSelectRegion(val);
                        setSelectArea("");
                        form.setFieldValue("area", undefined);
                        form.setFieldValue("teritory", undefined);
                      }}
                      disabled={!!selectCluster}
                    />
                  </Form.Item>

                  <Form.Item
                    name="area"
                    label="Select Zonal"
                    rules={[
                      {
                        required: true,
                        message: "Please select zonal",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select Zonal"
                      size="large"
                      allowClear
                      showSearch
                      options={getAllPGAreaData?.data?.map((area: any) => ({
                        label: capitalize(area.areaName),
                        value: area._id,
                      }))}
                      onChange={(val) => {
                        setSelectArea(val);
                        form.setFieldValue("teritory", undefined);
                      }}
                      disabled={!selectRegion}
                      loading={getAllPGAreaIsLoading}
                    />
                  </Form.Item>

                  <Form.Item
                    name="teritory"
                    label="Select Territory"
                    rules={[
                      {
                        required: true,
                        message: "Please select territory",
                      },
                    ]}
                  >
                    <Select
                      placeholder="Select territory"
                      size="large"
                      allowClear
                      showSearch
                      options={getAllPGTerritoriesData?.data?.map(
                        (territory: any) => ({
                          label: capitalize(territory.teritoryName),
                          value: territory._id,
                        })
                      )}
                      disabled={!selectArea}
                      loading={getAllPGTerritoriesIsLoading}
                    />
                  </Form.Item>
                </>
              )}
            </div>
          </CustomCard>
          <div className="p-6 rounded-md rounded-t-none bg-white border border-t-0 border-light">
            <Space className="w-full mt-2" size={12}>
              <Link
                to={`/admin/users-roll-access/roll-access/product-access/${companyId}/${projectId}/${projectName}/${serviceName}`}
              >
                <Button
                  className="normal-dark-button modal-button"
                  size="middle"
                >
                  Cancel
                </Button>
              </Link>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                loading={isAssignRoleLoading}
              >
                {"Add Role"}
              </Button>
            </Space>
          </div>
        </Form>
      </SidebarLayout>
    </>
  );
}
